import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper
} from 'vuex-smart-module'
import _ from 'lodash'
import DictsAPI from '@/api/requests/dicts'
import DictsAdapter from '@/api/adapters/dicts'
import CttAPI from '@/api/requests/ctt'

class DictsState {
  authorDegree: any[] = []
  authorPosition: any[] = []
  publicationQuartile: any[] = []
  conferenceType: any[] = []
  conferenceForm: any[] = []
  type: any[] = []
  classifiersVac: any[] = []
  classifiersMon: any[] = []
  labourRel: any[] = []
  workPositions: any[] = []
  academicDegree: any[] = []
  workDepartments: any[] = []
  workFunctions: any[] = []
  academicTitles: any[] = []
  studentGroups: any[] = []
  ridTypes: any[] = []
  techRegions: any[] = []
}

class DictsGetters extends Getters<DictsState> {
  classifiersVac() {
    return this.state.classifiersVac
  }
  classifiersMon() {
    return this.state.classifiersMon
  }
  publicationQuartile() {
    return this.state.publicationQuartile
  }
  ridTypes() {
    return this.state.ridTypes
  }
  techRegions() {
    return this.state.techRegions
  }
}

class DictsMutations extends Mutations<DictsState> {
  setAuthorDegree(authorDegree: []) {
    this.state.authorDegree = authorDegree
  }
  setAuthorPosition(authorPosition: []) {
    this.state.authorPosition = authorPosition
  }
  setPublicationQuartile(publicationQuartile: []) {
    this.state.publicationQuartile = _.sortBy(publicationQuartile, 'short')
  }
  setConferenceType(conferenceType: []) {
    this.state.conferenceType = conferenceType
  }
  setConferenceForm(conferenceForm: []) {
    this.state.conferenceForm = conferenceForm
  }
  setPublicationType(type: []) {
    this.state.type = type
  }
  setClassifiersVac(classifiersVac: []) {
    this.state.classifiersVac = classifiersVac
  }
  setClassifiersMon(classifiersMon: []) {
    this.state.classifiersMon = classifiersMon
  }
  setLabourRel(labourRel: []) {
    this.state.labourRel = labourRel
  }
  setWorkPositions(workPositions: []) {
    this.state.workPositions = workPositions
  }
  setAcademicDegree(academicDegree: []) {
    this.state.academicDegree = academicDegree
  }
  setWorkDepartments(workDepartments: []) {
    this.state.workDepartments = workDepartments
  }
  setWorkFunctions(workFunctions: []) {
    this.state.workFunctions = workFunctions
  }
  setAcademicTitles(academicTitles: []) {
    this.state.academicTitles = academicTitles
  }
  setStudentGroups(studentGroups: []) {
    this.state.studentGroups = studentGroups
  }
  setTechRegions(techRegions: []) {
    this.state.techRegions = techRegions
  }
  setRidTypes(ridTypes: []) {
    this.state.ridTypes = ridTypes
  }
}

class DictsActions extends Actions<
  DictsState,
  DictsGetters,
  DictsMutations,
  DictsActions
> {
  async fetchAlmostAllDicts() {
    try {
      if (
        _.isEmpty(this.state.authorDegree) ||
        _.isEmpty(this.state.authorPosition) ||
        _.isEmpty(this.state.publicationQuartile) ||
        _.isEmpty(this.state.type) ||
        _.isEmpty(this.state.classifiersVac) ||
        _.isEmpty(this.state.classifiersMon) ||
        _.isEmpty(this.state.workPositions) ||
        _.isEmpty(this.state.academicDegree) ||
        _.isEmpty(this.state.workDepartments) ||
        _.isEmpty(this.state.workFunctions) ||
        _.isEmpty(this.state.academicTitles) ||
        _.isEmpty(this.state.conferenceType) ||
        _.isEmpty(this.state.conferenceForm)
      ) {
        const response = await DictsAPI.getAlmostAllDict()
        this.mutations.setAuthorDegree(response.data.authorDegree)
        this.mutations.setAuthorPosition(response.data.authorPosition)
        this.mutations.setPublicationQuartile(response.data.publicationQuartile)
        this.mutations.setPublicationType(response.data.publicationType)
        this.mutations.setClassifiersVac(response.data.classifiersVAC)
        this.mutations.setClassifiersMon(response.data.classifiersMON)
        this.mutations.setLabourRel(response.data.labourRel)
        this.mutations.setWorkPositions(response.data.workPositions)
        this.mutations.setAcademicDegree(response.data.academicDegrees)
        this.mutations.setWorkDepartments(
          response.data.workDepartments.sort(DictsAdapter.sortByShortTitle)
        )
        this.mutations.setWorkFunctions(response.data.workFunctions)
        this.mutations.setAcademicTitles(response.data.academicTitles)
        this.mutations.setConferenceType(response.data.confType)
        this.mutations.setConferenceForm(response.data.confForm)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchAuthorDegree() {
    try {
      if (_.isEmpty(this.state.authorDegree)) {
        const response = await DictsAPI.getAuthorDegree()
        this.mutations.setAuthorDegree(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchAuthorPosition() {
    try {
      if (_.isEmpty(this.state.authorPosition)) {
        const response = await DictsAPI.getAuthorPosition()
        this.mutations.setAuthorPosition(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchPublicationQuartile() {
    try {
      if (_.isEmpty(this.state.publicationQuartile)) {
        const response = await DictsAPI.getPublicationQuartile()
        this.mutations.setPublicationQuartile(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchConferenceType() {
    try {
      if (_.isEmpty(this.state.conferenceType)) {
        const response = await DictsAPI.getConferenceType()
        this.mutations.setConferenceType(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchConferenceForm() {
    try {
      if (_.isEmpty(this.state.conferenceForm)) {
        const response = await DictsAPI.getConferenceForm()
        this.mutations.setConferenceForm(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchPublicationType() {
    try {
      if (_.isEmpty(this.state.type)) {
        const response = await DictsAPI.getPublicationType()
        this.mutations.setPublicationType(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchClassifiersVac() {
    try {
      if (_.isEmpty(this.state.classifiersVac)) {
        const response = await DictsAPI.getClassifiersVac()
        this.mutations.setClassifiersVac(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchClassifiersMon() {
    try {
      if (_.isEmpty(this.state.classifiersMon)) {
        const response = await DictsAPI.getClassifiersMon()
        this.mutations.setClassifiersMon(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchLabourRel() {
    try {
      if (_.isEmpty(this.state.labourRel)) {
        const response = await DictsAPI.getLabourRel()
        this.mutations.setLabourRel(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchWorkPositions() {
    try {
      if (_.isEmpty(this.state.workPositions)) {
        const response = await DictsAPI.getWorkPositions()
        this.mutations.setWorkPositions(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchAcademicDegree() {
    try {
      if (_.isEmpty(this.state.academicDegree)) {
        const response = await DictsAPI.getAcademicDegree()
        this.mutations.setAcademicDegree(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchWorkDepartments() {
    try {
      if (_.isEmpty(this.state.workDepartments)) {
        const response = await DictsAPI.getWorkDepartments()
        this.mutations.setWorkDepartments(
          response.data.sort(DictsAdapter.sortByShortTitle)
        )
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchWorkFunctions() {
    try {
      if (_.isEmpty(this.state.workFunctions)) {
        const response = await DictsAPI.getWorkFunctions()
        this.mutations.setWorkFunctions(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchAcademicTitles() {
    try {
      if (_.isEmpty(this.state.academicTitles)) {
        const response = await DictsAPI.getAcademicTitles()
        this.mutations.setAcademicTitles(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchStudentGroups() {
    try {
      if (_.isEmpty(this.state.studentGroups)) {
        const response = await DictsAPI.getStudentGroups()
        this.mutations.setStudentGroups(
          response.data.rows.sort(DictsAdapter.sortByShortGroup)
        )
      }
    } catch (err) {
      console.error(err)
    }
  }
  async fetchCttDicts() {
    try {
      //if (_.isEmpty(this.state.studentGroups)) {
      const response1 = await CttAPI.getReferences('techRegions')
      this.mutations.setTechRegions(response1.data)
      const response2 = await CttAPI.getReferences('ridTypes')
      this.mutations.setRidTypes(response2.data)
      //}
    } catch (err) {
      console.error(err)
    }
  }
}

export const dicts = new Module({
  state: DictsState,
  getters: DictsGetters,
  mutations: DictsMutations,
  actions: DictsActions
})

export const dictsMapper = createMapper(dicts)
